import React from 'react';
import {baseUrl, authUrl,} from '../config.js';
import axios from 'axios';
import store from '../redux/store.js';
import setAuthToken from './setAuthToken';
import {updateTokens,logoutUser} from '../redux/actions/authActions';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import {jwtDecode} from "jwt-decode";


axios.defaults.headers.common["Content-Type"] = 'application/json;charset=utf-8'
//axios.defaults.headers.common["Content-Type"] = 'multipart/form-data;charset=utf-8'
// axios.interceptors.request.use((config) => {
//     return config;
//   });

  axios.interceptors.request.use(config => {
    if (config.url.includes('amazonaws.com')) {
      delete config.headers['Authorization'];
    }
    return config;
  });

const makeRequestCreator = () => {
  let call;
  return (url, params) => {
    if (call) {
      call.cancel("Only one request allowed at a time.");
    }
    call = axios.CancelToken.source();
    return axios.post(url, params,{
      cancelToken: call.token
    });
  };
};

const get = makeRequestCreator();

export const fetchListData = async (url,params) => {
  try {
    const res = await get(url, params);
    // do something with res
    if(res) {
      return res.data;
    } else {
      throw 'error fetching data';
    }

  } catch(err) {
      if (axios.isCancel(err)) {
        throw err.message;
    } else {
    }
  }
}


axios.interceptors.request.use(
    async config => {
        let userToken = await store.getState().auth.access_token;
        config.headers = {
            'Authorization': `Bearer ${userToken}`,
            'Accept': 'application/json, text/plain, */*, multipart/form-data'
        }
        return config;
    },
    error => {
        Promise.reject(error)
    }
  );

  const refreshAuthLogic = failedRequest =>
                  axios({
                    method:'POST',
                    url:authUrl + '/auth/refresh-token',
                    data:{
                      refreshToken: store.getState().auth.refresh_token
                    }
                  }).then(tokenRefreshResponse => {
                                              setAuthToken(tokenRefreshResponse.data.access_token);
                                              var deca = jwtDecode(tokenRefreshResponse.data.access_token)
                                              store.dispatch({
                                                type:'UPDATE_TOKENS',
                                                payload:tokenRefreshResponse.data
                                              })
                                              // const storeme = {
                                              //   tokens: tokenRefreshResponse.data,
                                              //   profile:store.getState().profile.user,
                                              //   active:true
                                              // }
                                              // //const jsonStoreme = JSON.stringify(storeme);
                                              // AsyncStorage.getItem('douguser').then(res=>{
                                              //   var unload = JSON.parse(res);
                                              //   var index = unload.findIndex(e=>e.profile._id == storeme.profile._id);
                                              //   unload[index] = storeme;
                                              //   AsyncStorage.setItem('douguser',JSON.stringify(unload));
                                              // }).catch(err=>{
                                              // })


      failedRequest.response.config.headers['Authorization'] = 'Bearer ' + tokenRefreshResponse.data.access_token;
      failedRequest.response.config.headers['Content-Type'] = 'application/json;charset=utf-8';
      return Promise.resolve();
  }).catch(error=>{
    store.dispatch(logoutUser(store.getState().profile?.user)).then(res=>{
    }).catch(error=>{

    })
    return Promise.reject();
  })

  // Instantiate the interceptor
  createAuthRefreshInterceptor(axios, refreshAuthLogic,{
});


class API {
   fetch({method,endpoint,data}) {
     return new Promise(function(resolve,reject){
       axios({
         method:method,
         url:baseUrl + endpoint,
         data:data,
       }).then(result=>{
         resolve(result);
       }).catch(error=>{
         reject(error);
       })
     })
   }

 async uploadimage({file}) {
  const fileType = file.type;
  try {
      var response = await axios.get(baseUrl +'/image/getuploadurl');
      const { url, key } = response.data;
    console.log('WE COGT THE FILE UPLOAD URL',response)
      // Step 3: Convert the file to Blob using fetch
      // const responseBlob = await fetch(fileUri);
      // const fileBlob = await responseBlob.blob();

      // Log the Blob details


      const uploadResponse = await fetch(url, {
        method: 'PUT',
        body: file,
        headers: {
          'Content-Type': fileType,
        },
      });

      if (uploadResponse.status === 200) {
      } else {
        console.error('Upload failed:', uploadResponse.statusText);
      }


    return key;
    } catch(error) {
    }
}

async fetchlink() {
  try {
    var response = await axios.get(baseUrl +'/image/getuploadurl');
    return;
  } catch(error) {
    return;
  }
}


}
export default new API();
